.hasClearIcon .inputRoot {
  padding-right: 16px;
}

.paper {
  border-radius: 0;
}
